{
	"page": {
		"title": "Search",
		"subtitle": "Across StudyHub: materials, notes, flashcards, quizzes",
		"placeholder": "Find a material, note, flashcard…",
		"controls": {
			"semantic": "Semantic",
			"semanticHint": "Understands meaning, not just words",
			"clear": "Clear",
			"filters": "Filters"
		}
	},
	"tabs": {
		"all": "All",
		"topics": "Topics",
		"materials": "Materials",
		"collections": "Folders",
		"notes": "Notes",
		"flashcards": "Flashcards",
		"quizzes": "Quizzes",
		"chats": "Chats"
	},
	"groups": {
		"topics": "Course topics",
		"materials": "Materials",
		"collections": "Folders",
		"notes": "Notes",
		"flashcards": "Flashcards",
		"quizzes": "Quizzes",
		"chats": "Chats",
		"actions": "Actions",
		"recents": "Recent queries",
		"viewAll": "View all"
	},
	"empty": {
		"initial": {
			"title": "What are you looking for?",
			"hint": "Type a query or press Tab for commands",
			"popular": "Popular",
			"popularQueries": [
				"mitochondria",
				"photosynthesis",
				"derivative",
				"SAT",
				"Krebs"
			],
			"recents": "Recent"
		},
		"zero": {
			"title": "Nothing found",
			"subtitle": "Try different words or enable semantic search",
			"suggestion": "Refining the topic or language often helps"
		},
		"offline": {
			"title": "Search needs a connection",
			"subtitle": "Global search works online. Check your network and try again."
		}
	},
	"loading": "Searching…",
	"error": {
		"title": "Search failed",
		"hint": "Check your connection and try again",
		"retry": "Retry"
	},
	"filters": {
		"title": "Filters",
		"reset": "Reset",
		"language": "Language",
		"tags": "Tags",
		"sourceType": "Source type",
		"material": "Material",
		"set": "Folder"
	},
	"result": {
		"pages": "{count, plural, one {# page} other {# pages}}",
		"openedAt": "Opened {when}",
		"loadMore": "Load more",
		"showing": "Showing {from}–{to} of {total}"
	}
}
